import React, { useEffect, useCallback, useState, useRef } from "react";
import Select from "react-select";
import { toast, ToastContainer } from "react-toastify";
import ExcelJS from 'exceljs';
import { fetchGrossisteSite } from "../../Redux/grossisteReduce";
import { fetchProduit } from "../../Redux/produitReduce";
import { verification } from "../../Redux/usersReduce";
import { useTranslation } from 'react-multi-lang';
import SweetAlert from "react-bootstrap-sweetalert";
import {
  commandeAddedExcel,
  saveFile,
  cheeckProduit,
  verifCmd, getNumCommandGros
} from "../../Redux/commandeReduce";
import { useDispatch } from "react-redux";
import ReactTable from "../../components/ReactTable/ReactTableBl.js";
import { Alert } from "react-bootstrap";
import { Button, Card, Form, Container, Row, Col } from "react-bootstrap";
import { verifGrous } from "./VerifExcel/verifGrous";
import jwt_decode from "jwt-decode";
import Swal from 'sweetalert2';

function AddCommandeExcel({ obj, client }) {
  const t = useTranslation();
  var token = localStorage.getItem("x-access-token");
  var decoded = jwt_decode(token);
  const idUser = obj.user.id_role == 6 ? obj.user.id_grossiste : null;
  const id_site = client == "/medis" ? 2 : 3;

  const saveTableCalled = useRef(false);
  const notify = (type, msg) => {
    if (type === 1)
      toast.success(<strong>{msg}</strong>);
    else
      toast.error(<strong>{msg}</strong>);
  }
  const dispatch = useDispatch();
  const [produitExist, setProduitExist] = React.useState([]);
  const [produitExistDeleted, setProduitExistDeleted] = React.useState([]);
  const [remise_industrie3, setRemise_industrie3] = useState(obj.user.id_role == 6 ? obj.user.remise_industrie3 : 0);
  const [remise_industrie2, setRemise_industrie2] = useState(obj.user.id_role == 6 ? obj.user.remise_industrie2 : 0);
  const [fourSelected, setFourSelected] = React.useState(null); const [optionFour, setOptionFour] = React.useState([
    {
      value: "",
      label: t("Wholesaler"),
      isDisabled: true,
    },
  ]);

  //getDate today
  var currentDate = new Date();
  var year = currentDate.getFullYear();
  var month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
  var day = currentDate.getDate().toString().padStart(2, '0');
  var formattedDate = year + '-' + month + '-' + day;


  //Produit en vrac
  const [resteZero, setResteZero] = useState(0);
  const [entitiesReste, setEntitiesReste] = useState([]);

  const [numCmd, setNumCmd] = useState(null);
  const [alert, setAlert] = useState(null);
  const [txtAlert, setTxtAlert] = React.useState("");
  const [entitiesEntete, setEntitiesEntete] = useState([{ Date: formattedDate, id_grossiste: idUser, Grossiste: null, Numero: null }]);
  const [isDisabled, setIsDisabled] = React.useState(false);
  const [total, setTotal] = useState(0);
  const [grosSelected, setGrosSelected] = React.useState(null);
  const [optionGros, setOptionGros] = React.useState([
    {
      value: "",
      label: t("Wholesaler"),
      isDisabled: true,
    },
  ]);

  const [typeSelect, setTypeSelect] = React.useState([]);


  const [testAffiche, setTestAffiche] = useState(true);

  //table body
  const [entities, setEntities] = useState([]);
  const [uploadFile, setUploadFile] = React.useState();
  const [verif, setVerif] = React.useState(false);
  //Produit
  const [produitSelect, setProduitSelect] = React.useState([]);
  const [optionProduit, setOptionProduit] = React.useState([
    {
      value: "",
      label: "Produit",
      isDisabled: true,
    },
  ]);

  /** start crop img**/
  const [fileName, setFileName] = useState("");
  /** end crop img**/
  /*****excel*/
  const getNumCmd = useCallback(async (idUser) => {
    // Get the last command number for this user
    const num = await dispatch(getNumCommandGros({ id_grossiste: idUser }));

    const now = new Date();
    const currentYear = now.getFullYear().toString().slice(-2); // e.g., "25"
    const currentMonth = (now.getMonth() + 1).toString().padStart(2, "0"); // e.g., "09"

    let formattedNum = '';

    if (!num.payload.num) {
      // No existing number → start at 001
      formattedNum = `CD-${currentYear}-${currentMonth}-001`;
    } else {
      // Split last number: "CD-25-09-007"
      const parts = num.payload.num.split("-");
      const existingYear = parts[1];
      const existingMonth = parts[2];
      const lastIncrement = parseInt(parts[3]);

      // Increment if same month & year, else reset
      const newIncrement =
        existingYear === currentYear && existingMonth === currentMonth
          ? lastIncrement + 1
          : 1;

      formattedNum = `CD-${currentYear}-${currentMonth}-${newIncrement
        .toString()
        .padStart(3, "0")}`;
    }

    // Update state
    setNumCmd(formattedNum);

    setEntitiesEntete(prev => {
      if (!prev || prev.length === 0) return [{ Numero: formattedNum }]; // create first row if empty
      const updated = [...prev];
      updated[0] = { ...updated[0], Numero: formattedNum }; // update existing first row
      return updated;
    });


  }, [dispatch, entitiesEntete]);


  const fileHandler = async (e) => {
    const fileObj = e.target.files[0];
    if (!fileObj) return;

    setUploadFile(fileObj);

    // Clean file name
    const str = fileObj.name.replace(/[^a-zA-Z0-9,;\-.!? ]/g, "");
    setFileName(str);

    const fileName = fileObj.name.toLowerCase();

    if (fileName.endsWith(".csv")) {
      // ✅ Handle CSV file
      const reader = new FileReader();
      reader.onload = async (evt) => {
        const text = evt.target.result;

        // Split into lines & columns
        const lines = text.split("\n").filter((line) => line.trim() !== "");
        const excelData = lines.map((line) => line.split(";").map(cell => cell.trim()));


        const arrayBody = await verifGrous(excelData);
        checkProd(arrayBody);
      };
      reader.readAsText(fileObj, "utf-8");
    } else if (fileName.endsWith(".xlsx")) {
      // ✅ Handle Excel file (XLSX)
      const reader = new FileReader();
      reader.onload = async (evt) => {
        const buffer = evt.target.result;

        const workbook = new ExcelJS.Workbook();
        await workbook.xlsx.load(buffer);

        const worksheet = workbook.worksheets[0];

        const excelData = [];
        worksheet.eachRow({ includeEmpty: true }, (row) => {
          excelData.push(row.values.slice(1)); // skip first empty index
        });


        const arrayBody = await verifGrous(excelData);
        checkProd(arrayBody);
      };
      reader.readAsArrayBuffer(fileObj);
    } else {
      notify(2, "❌ Unsupported file type. Please upload a .xlsx or .csv file.");
    }
  };


  //get Produit
  const getproduit = useCallback(async (remise_industrie2, remise_industrie3) => {
    var type = await dispatch(fetchProduit({ client }));
    var entities = type.payload;
    var arrayOption = [];
    entities.forEach((e) => {
      arrayOption.push({
        value: e.id, label: e.Designation_1, code: e.Code_PCT, code_article: e.Code_article, type: e.type, prix: parseFloat(e.Prix).toFixed(3), cartonnage: e.Coefficient_UC,
        reste: null, commerce: e.commerce, id_site: e.id_site, tag: e.tag, site_produit: null, Remise: e.Remise === 1
          ? client === "/medis"
            ? remise_industrie2
            : remise_industrie3
          : 0
      });
    });
    setOptionProduit(arrayOption);
  }, [dispatch]);

  function deleteLigne(nb) {
    if (entities.length > 1) {
      const list = [...entities]
      const prod = [...produitExist]
      var filtered = produitSelect.filter(function (value, index, arr) {
        return index !== parseInt(nb);
      });
      setProduitSelect(filtered);
      filtered = typeSelect.filter(function (value, index, arr) {
        return index !== parseInt(nb);
      });
      filtered = entities.filter(function (value, index, arr) {
        return index !== parseInt(nb);
      });

      var filteredExist = prod.filter(function (value, index, arr) {
        return value.produitfour !== list[nb].produitfour;
      });

      calculateTotalSum(filtered)
      setEntities(filtered);
      setProduitExist(filteredExist);
      notify(1, t("supprimer_succes"));
    } else {
      notify(2, t("contient_ligne"));
    }
  }
  const checkProd = useCallback(
    async (table, numCmd) => {

      var arrayBody = [];
      var nocommerce = [];
      dispatch(cheeckProduit(table)).then((rowsdes) => {
        if (rowsdes !== undefined && rowsdes.payload.length > 0) {
          var prod = rowsdes.payload;
          var produitexit = [];
          for (let i = 0; i < prod.length; i++) {
            var reste = null
            var nbCarton = 0
            table[i].quantite = parseInt(table[i].quantite)
            if (table[i].quantite > 0) {

              if (prod[i] !== null && typeof prod[i] !== "undefined" && prod[i] !== "undefined" && prod[i][8]==id_site) {
                let style = null;
                const quantiteInitiale = table[i].quantite;
                const carton = parseInt(prod[i][6]);

                let resteDansCarton = quantiteInitiale / carton;

                // Ajout : arrondi si ≥ 60% de la contenance
                if (prod[i][9] == 2 && carton > 0 && resteDansCarton >= 0.6) {
                  table[i].quantite = Math.ceil(table[i].quantite / carton) * carton
                  var seuil = carton * 0.6;
                  style = "red";
                  setTimeout(() => {
                    notify(2, `Le produit ${prod[i][0]} doit être arrondi en caisse pour la quantité sup ${seuil}`);
                  }, 2000);
                }

                // Recalcul après éventuel arrondi
                if (table[i].quantite < carton) {
                  reste = carton - table[i].quantite;
                } else if ((table[i].quantite % carton) > 0) {
                  reste = carton - (table[i].quantite % carton);
                }

                // console.log(prod[i][9], table[i].quantite, table[i].Code, reste)

                if ((prod[i][9] == 1) && reste > 0) {
                  table[i].quantite += reste;
                  reste = 0
                  style = "red";
                  setTimeout(() => {
                    notify(2, `Le produit ${prod[i][0]} n’est recommandable que par multiple de carton`);
                  }, 2000);
                }

                nbCarton = carton > 0 ? parseInt(table[i].quantite / carton) : 0;

                let remiseDecimal = 0;
                if (prod[i][10] === 1) {
                  remiseDecimal =
                    client === "/medis"
                      ? remise_industrie2
                      : remise_industrie3;

                  remiseDecimal = typeof remiseDecimal === "number" ? remiseDecimal : parseFloat(remiseDecimal);
                  if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;
                }

                arrayBody.push({
                  idProduit: prod[i][2],
                  index: i,
                  designation: table[i].Designation != "" ? table[i].Designation : prod[i][0],
                  code: table[i].Code.toString().toLowerCase() != "not found" ? table[i].Code : "",
                  quantite: prod[i][7] == 1 ? table[i].quantite : 0,
                  prix: parseFloat(prod[i][4]).toFixed(3),
                  cartonnage: prod[i][7] == 1 ? carton : 0,
                  reste: prod[i][7] == 1 ? reste : 0,
                  nb: prod[i][7] == 1 ? nbCarton : 0,
                  commerce: prod[i][7],
                  id_site: prod[i][8],
                  code_article: prod[i][3],
                  site_produit: null,
                  tag: prod[i][9],
                  type: prod[i][11],
                  style: style,
                  Remise: prod[i][10] === 1
                    ? client === "/medis"
                      ? remise_industrie2
                      : remise_industrie3
                    : 0,
                  total: (
                    parseFloat(prod[i][4]) * parseInt(table[i].quantite) * (1 - remiseDecimal)
                  ).toFixed(3)
                });

                if (prod[i][7] == 0) {
                  nocommerce.push(table[i].Designation + " " + table[i].Code + " est non plus commercialisé ");
                }
              }
              else {
                if (table[i].Code !== "" && table[i].Code !== null)
                  produitexit.push({ index: i + 1, designation: table[i].Designation, produitfour: table[i].Designation, code: table[i].Code, quantite: table[i].quantite });
                arrayBody.push({
                  idProduit: null,
                  index: i,
                  designation: table[i].Designation,
                  produitfour: table[i].Designation,
                  site_produit: null,
                  code: table[i].Code,
                  quantite: table[i].quantite,
                  prix: 0,
                  cartonnage: 0,
                  tag: 0,
                  reste: null,
                  type: null,
                  commerce: null,
                  id_site: null,
                  nb: 0,
                  Remise: 0,
                  code_article: '',
                  total: 0,
                });
              }
            }
          }
          if (produitexit.length > 0) setProduitExist(produitexit);
          calculateTotalSum(arrayBody)
          setEntities(arrayBody);
          document.getElementById("loaderTable").classList.add("hidden");
          setVerif(true);
          if (nocommerce.length > 0) for (var i = 0; i < nocommerce.length; i++) {
            notify(2, nocommerce[i]);
          }
        } else {

          // document.getElementById("loaderTable").classList.add("hidden");
          // notify(2, t("verify_file"));
          // setTimeout(() => {
          //   window.location.replace("/addCommandeExcel")
          // }, 1000);
          document.getElementById("loaderTable").classList.add("hidden");
          setEntities([]);
        }


      });
    },
    [dispatch]
  );
  const setTable = useCallback(
    async (table, init) => {
      //1 => update table ***** 0 => initialiser table
      var arrayBody = [];
      if (init === 1) {
        table.forEach((value) => {
          arrayBody.push({
            code: value.code,
            index: value.index,
            idProduit: value.idProduit,
            designation: value.designation,
            quantite: value.quantite,
            prix: value.prix,
            code_article: value.code_article,
            reste: value.reste,
            cartonnage: value.cartonnage,
            tag: value.tag,
            total: value.total,
            style: value.style,
            nb: value.nb,
            type: value.type,
            commerce: value.commerce,
            site_produit: value.site_produit,
            Remise: value.Remise,
            id_site: value.id_site,
          });
        });
        setEntities(arrayBody);
      } else {
        checkProd(table);
      }
    },
    [checkProd]
  );

  //get grossiste
  const getGrossiste = useCallback(async () => {
    var grossiste = await dispatch(fetchGrossisteSite({ client }));
    var entities = grossiste.payload;
    var arrayOption = [];
    entities.forEach((e) => {
      arrayOption.push({ value: e.id_grossiste, label: e.raison_sociale, remise_industrie3: e.grossistes?.remise_industrie3, remise_industrie2: e.grossistes?.remise_industrie2 });
    });
    setOptionFour(arrayOption);
  }, [dispatch]);




  function getProduitReste(list, resteZero) {
    const filteredList = list.filter(item => {
      if (resteZero === 1) {
        if (item.idProduit != null) return item.reste != 0 && item.reste != null;
      } else {
        return true;
      }
    });
    setEntitiesReste(filteredList)
  }


  const showTable = useCallback(
    async (file, entities) => {
      if (
        file
      ) {
        if (typeof file === "object") {
          var element = document.getElementById("table-BL");
          element.classList.remove("hidden");
          notify(1, t("extraction_success"));
        } else {
          notify(2, t("problem"));
        }
      }
    },
    [dispatch, fileName]
  );

  const removeProduit = useCallback(
    async (list2, select, id, produitExist) => {
      var list = [...list2]
      list[id].idProduit = null;
      list[id].designation = null;
      list[id].prix = 0;
      list[id].total = 0;
      list[id].cartonnage = 0;
      list[id].id_site = null;
      list[id].reste = 0;
      list[id].Remise = 0;
      list[id].nb = 0;
      list[id].tag = 0;
      list[id].code_article = null;
      list[id].site_produit = null;
      list[id].type = null;
      select[id] = null;
      setProduitSelect(select);
      setEntities(list);
      setTable(list, 1);
    },
    [setTable]
  );


  const hideAlert = () => {
    setAlert(null);
  };

  const confirmMessageProduit = (entities, produitSelect, rowIndex, v, produitExist, produitExistDeleted, remise_industrie2, remise_industrie3) => {
    var e = [...entities];
    const index = e.findIndex(item => item.idProduit === v.value);
    var select = [...produitSelect];
    select[rowIndex] = null
    setProduitSelect(select);
    if (index !== -1) {

      setAlert(
        <SweetAlert
          title=""
          style={{ display: "block", marginTop: "-100px" }}
          success
          onConfirm={() => confirmProduit(entities, produitSelect, rowIndex, v, produitExist, produitExistDeleted, remise_industrie2, remise_industrie3)}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="success"
          cancelBtnBsStyle="danger"
          confirmBtnText={t("yes")}
          cancelBtnText={t("no")}
          showCancel
        >
          <h3 className="alert-title">{t("valider_produit")}</h3>
          {t("valider_produit_msg")}?
        </SweetAlert>
      );
    } else {
      confirmProduit(entities, produitSelect, rowIndex, v, produitExist, produitExistDeleted, remise_industrie2, remise_industrie3)
    }
  };


  const confirmProduit = useCallback(
    async (entities, produitSelect, rowIndex, v, produitExist, produitExistDeleted, remise_industrie2, remise_industrie3) => {
      var e = [...entities];
      hideAlert()
      var select = [...produitSelect];
      e[rowIndex].idProduit = v.value;
      e[rowIndex].designation = v.label;
      e[rowIndex].code = v.code;
      e[rowIndex].code_article = v.code_article;
      e[rowIndex].prix = v.prix;
      e[rowIndex].type = v.type;
      e[rowIndex].id_site = v.id_site;
      e[rowIndex].site_produit = v.site_produit;
      e[rowIndex].tag = v.tag;

      e[rowIndex].Remise = v.Remise

      let remiseDecimal = 0;
      if (e[rowIndex].Remise && e[rowIndex].Remise !== 0) {
        remiseDecimal =
          typeof e[rowIndex].Remise === "number"
            ? e[rowIndex].Remise
            : parseFloat(e[rowIndex].Remise);
        if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;
      }

      let quantite = parseInt(e[rowIndex].quantite) || 0;

      if (v.cartonnage > 0 && quantite / v.cartonnage >= 0.6 && v.tag == 2) {
        quantite = Math.ceil(quantite / v.cartonnage) * v.cartonnage;
        const seuil = v.cartonnage * 0.6;
        notify(2, `Le produit doit être arrondi en caisse pour la quantité sup ${seuil}`);
      }

      e[rowIndex].quantite = quantite;
      e[rowIndex].nb = v.cartonnage > 0 && quantite ? parseInt(quantite / v.cartonnage) : 0;

      if (quantite && quantite < v.cartonnage) {
        e[rowIndex].reste = v.cartonnage - quantite;
      } else if (quantite % v.cartonnage > 0) {
        e[rowIndex].reste = v.cartonnage - (quantite % v.cartonnage);
      } else {
        e[rowIndex].reste = 0;
      }
      if ((e[rowIndex].tag == 1) && e[rowIndex].reste > 0) {
        e[rowIndex].quantite += e[rowIndex].reste
        quantite += e[rowIndex].reste
        e[rowIndex].reste = 0
        e[rowIndex].nb += 1
        e[rowIndex].style = "red"
        notify(2, "Le produit n’est recommandable que par multiple de carton");
      }

      e[rowIndex].total = quantite ? parseInt(v.prix * quantite * (1 - remiseDecimal)).toFixed(3) : 0;
      e[rowIndex].cartonnage = v.cartonnage;
      e[rowIndex].commerce = v.commerce;




      select[rowIndex] = v;
      setProduitSelect(select);

      const prod = [...produitExist]
      var filteredExist = prod.filter(function (value, index, arr) {
        return value.produitfour !== e[rowIndex].produitfour;
      });
      const prodD = [...produitExistDeleted]
      var filteredExistD = prodD.filter(function (value, index, arr) {
        return value.produitfour !== e[rowIndex].produitfour;
      });
      setProduitExist(filteredExist);
      setProduitExistDeleted(filteredExistD);
      setEntities(e);
      calculateTotalSum(e)
      setTable(e, 1);
    },
    []
  );

  const saveTable = useCallback(
    async (
      entities,
      entitiesEntete,
      uploadFile,
      grosSelected,
      total,
      produitExistDeleted
    ) => {
      var verif = true;
      var verifReste = true;
      document.getElementById("saveBL").classList.add("hidden");
      var ligneMsg = []
      if (entities.length > 0) {
        entities.forEach((data) => {
          if (data.idProduit === null) { verif = false; ligneMsg.push(data.index + 1) }
        });
        entities.forEach((data) => {
          if (data.commerce == 1 && (data.quantite == 0 || data.quantite == "" || data.quantite == null || isNaN(data.quantite))) { verif = false; ligneMsg.push(data.index + 1) }
        });
        entities.forEach((data) => {
          if ((data.tag == 1) && data.reste > 0) verifReste = false;
        });
      } else {
        verif = false;
      }
      if (verifReste == false) {
        notify(2, "Le produit n’est recommandable que par multiple de carton");
        return
      }
      if (verif === false || entitiesEntete[0].id_grossiste == null) {
        setIsDisabled(false)
        document.getElementById("saveBL").classList.remove("hidden");
        if (ligneMsg.length > 0) notify(2, "Vérifier les lignes : " + ligneMsg.join(" ,"));
        else notify(2, t("erreur"));
        saveTableCalled.current = false
      } else {
        dispatch(
          verifCmd({
            grossiste: entitiesEntete[0].id_grossiste,
            numero: entitiesEntete[0].Numero,
          })
        ).then(async (e) => {
          if (e.payload === false) {
            const dataArray = new FormData();
            dataArray.append("file", uploadFile);
            dataArray.append("name", uploadFile.name);
            if (entitiesEntete[0].id_grossiste !== null) {
              setIsDisabled(false)
              if (saveTableCalled.current) return;
              saveTableCalled.current = true
              let divise = 0;
              const types = [...new Set(entities.filter(e => parseInt(e.quantite) > 0).map(e => e.type))];
              console.log(types)
              console.log(entities)
              if (types.length > 1) {
                const result = await Swal.fire({
                  title: 'Division Commande',
                  text: "La commande contient plusieurs types (AMM et AMC). Voulez-vous diviser la commande ?",
                  icon: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Oui, diviser',
                  cancelButtonText: 'Non',
                });

                if (result.isConfirmed) {
                  divise = 1;
                }
              }


              setIsDisabled(true)
              document.getElementById("saveBL").classList.add("hidden");
              dispatch(saveFile(dataArray)).then((e) => {
                var filename = e.payload.filename;
                if (filename != null) {
                  dispatch(
                    commandeAddedExcel({
                      Montant: total,
                      type_insert: 3,
                      id_site: client == "/medis" ? 2 : 3,
                      file: filename,
                      namefile: uploadFile.name,
                      ligneCommande: entities,
                      enteteCmd: entitiesEntete,
                      produitExistDeleted: produitExistDeleted, divise
                    })
                  ).then((e) => {
                    if (e.payload === true) {
                      notify(1, t("add_txt"));
                      setTimeout(() => {
                        window.location.replace(client + "/commandeList")
                      }, 800);
                    } else {
                      document.getElementById("saveBL").classList.remove("hidden");
                      setIsDisabled(false)
                      saveTableCalled.current = false
                      notify(2, t("cmd_deja"));
                    }
                  });
                } else {
                  document.getElementById("saveBL").classList.remove("hidden");
                  setIsDisabled(false)
                  saveTableCalled.current = false
                  notify(2, t("problem"));
                }
              });

            } else {
              document.getElementById("saveBL").classList.remove("hidden");
              setIsDisabled(false)
              saveTableCalled.current = false
              notify(2, t("Grossiste.obligatoire"));
            }
          } else {
            document.getElementById("saveBL").classList.remove("hidden");
            setIsDisabled(false)
            saveTableCalled.current = false
            notify(2, t("cmd_deja"));
          }
        });
      }
    },
    [dispatch]
  );

  function AjoutLigne(event) {
    var list = [];
    if (entities.length > 0) list = [...entities];
    list[list.length] = {
      code: null,
      index: list.length,
      idProduit: null,
      designation: null,
      quantite: null,
      prix: 0,
      code_article: '',
      total: 0,
      cartonnage: 0,
      site_produit:null,
      Remise: 0,
      tag: 0,
      nb: 0,
      reste: null,
      id_site: null,
      commerce: null
    };
    setEntities(list);
  }
  const removeGrossiste = useCallback(async (list2, id) => {
    var list = [...list2]
    list[0].id_grossiste = null
    list[0].grossiste = null
    setEntitiesEntete(list)
  }, []);


  const ListTable = ({ entities, produitSelect, resteZero, list }) => {
    return (
      <table className="table table-add table-bordered">
        <thead>
          <tr className="table-info">
            <th>ID</th>
            <th>{t('code_pct')}</th>
            <th>{t('code_article')}</th>
            <th>{t('designation')}</th>
            <th>{t('Remise')}</th>
            <th>{t('prix')} (HT TND)</th>
            <th>{t('cartonnage')}</th>
            <th>{t('quantite_cmd')}</th>
            <th>{t('nb_carton')}</th>
            <th>{t('reste')}</th>
            <th>{t('prix_total')} (HT TND)</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody className="commande-import4">
          {entities.map((entity, index) => (
            <tr key={index} className={entity.commerce == 0 ? "no-commerce" : entity.reste > 0 ? "reste-warning" : null}>
              <td>{entity.index + 1}</td>
              <td> {entity.tag == 1 ? <i style={{ color: "#9C27B0", fontSize: "15px", marginRight: "10px" }} className="fa-solid fa-cube"></i> : null}{entity.code}</td>
              <td>{entity.code_article}</td>
              <td>
                <div id="roleClass">
                  {entity.idProduit !== null ? (
                    <Form.Group className="desinationProduit">
                      <Form.Control
                        className="green"
                        readOnly
                        value={entity.designation}
                        placeholder="Designation"
                        type="text"
                      ></Form.Control>
                      {entity.commerce == 1 ? (
                        <Button
                          variant="danger"
                          size="sm"
                          className="text-danger btn-link delete"
                          onClick={() => {
                            removeProduit(
                              entities,
                              produitSelect,
                              index,
                              produitExist
                            );
                          }}
                        >
                          <i className="fas fa-times"></i>
                        </Button>
                      ) : null}
                    </Form.Group>
                  ) : (
                    <div className="table-bl">
                      {entity.designation != null ? (
                        <Form.Group className="desinationProduit">
                          <Form.Control
                            className="red"
                            readOnly
                            value={
                              entity.designation
                            }
                            placeholder="Designation"
                            type="text"
                          ></Form.Control>
                        </Form.Group>
                      ) : (
                        ""
                      )}
                      <Select
                        className="react-select primary "
                        classNamePrefix="react-select"
                        name="Produit"
                        placeholder="Produit"
                        value={produitSelect[index]}
                        onChange={(v) => {
                          confirmMessageProduit(entities, produitSelect, index, v, produitExist, produitExistDeleted, remise_industrie2, remise_industrie3)
                        }}
                        options={optionProduit}
                      />
                    </div>
                  )}
                </div>
              </td>
              <td>{entity.Remise}</td>
              <td>{new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(entity.prix)}</td>
              <td>{entity.cartonnage}</td>
              <td>
                <Form.Group>
                  <input
                    className={entity.style === "red" ? "redBorder form-control" : "defaultBorder form-control"}
                    defaultValue={entity.quantite}
                    placeholder="quantite"
                    type="number"
                    pattern="\d+"
                    readOnly={entity.commerce == 1 ? false : true}
                    onBlur={(value) => {

                      let e = [...entities];

                      if (e[index].commerce == 1) {

                        let rawQuantite = parseInt(value.target.value.replace(/[^0-9]/g, '')) || 0;

                        if (
                          e[index].cartonnage > 0 &&
                          (rawQuantite / e[index].cartonnage >= 0.6) &&
                          e[index].tag == 2
                        ) {
                          rawQuantite = Math.ceil(rawQuantite / e[index].cartonnage) * e[index].cartonnage;

                          const seuil = e[index].cartonnage * 0.6;
                          e[index].style = "red"
                          notify(2, `Le produit doit être arrondi en caisse pour la quantité sup ${seuil}`);
                        }


                        e[index].quantite = rawQuantite;

                        e[index].nb = e[index].cartonnage > 0 ? parseInt(e[index].quantite / e[index].cartonnage) : 0

                        if (e[index].quantite > 0 && e[index].quantite < e[index].cartonnage) e[index].reste = parseInt(e[index].cartonnage - e[index].quantite)
                        else if (e[index].quantite > 0 && (e[index].quantite % parseInt(e[index].cartonnage)) > 0) {
                          e[index].reste = parseInt(e[index].cartonnage - (e[index].quantite % parseInt(e[index].cartonnage)))
                        } else if (e[index].quantite == 0) {
                          e[index].reste = null
                        } else {
                          e[index].reste = 0
                        }

                        if ((e[index].tag == 1) && e[index].reste > 0) {
                          e[index].quantite += e[index].reste
                          rawQuantite += e[index].reste
                          e[index].reste = 0
                          e[index].nb += 1
                          e[index].style = "red"
                          notify(2, "Le produit n’est recommandable que par multiple de carton");
                        }


                        let remiseDecimal = 0;
                        if (e[index].Remise && e[index].Remise !== 0) {
                          remiseDecimal = typeof e[index].Remise === "number" ? e[index].Remise : parseFloat(e[index].Remise);
                          if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;
                        }

                        e[index].total = rawQuantite
                          ? (e[index].prix * rawQuantite * (1 - remiseDecimal)).toFixed(3)
                          : 0;

                        if (resteZero == 1) {

                          list[e[index].index].nb = list[e[index].index].cartonnage > 0 ? parseInt(list[e[index].index].quantite / list[e[index].index].cartonnage) : 0

                          list[e[index].index].quantite = rawQuantite;

                          if (list[e[index].index].quantite < list[e[index].index].cartonnage) list[e[index].index].reste = parseInt(list[e[index].index].cartonnage - list[e[index].index].quantite)
                          else if ((list[e[index].index].quantite % parseInt(list[e[index].index].cartonnage)) > 0) {
                            list[e[index].index].reste = parseInt(list[e[index].index].cartonnage - (list[e[index].index].quantite % parseInt(list[e[index].index].cartonnage)))
                          } else {
                            list[e[index].index].reste = 0
                          }
                          list[e[index].index].total = (list[e[index].index].prix * parseInt(list[e[index].index].quantite) * (1 - remiseDecimal)).toFixed(3)

                          calculateTotalSum(list);
                          setEntities(list)
                        }

                        if (resteZero == 0) { setEntities(e); calculateTotalSum(e); }
                        else setEntitiesReste(e)

                      }
                    }}
                    onKeyDown={(event) => {
                      if (event.key === "Enter" || event.key === "Tab") {
                        event.preventDefault(); // Prevents form submission or default tabbing behavior
                        const nextIndex = parseInt(index) + 1;
                        const nextInput = document.querySelector(`input[name="Quantite-${nextIndex}"]`);
                        if (nextInput) {
                          nextInput.focus(); // Move to the next input
                        }
                      }
                    }}
                    name={`Quantite-${index}`}
                  />
                </Form.Group>
              </td>
              <td>{entity.nb}</td>
              <td>{entity.reste}</td>
              <td>{new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(entity.total)}</td>
              <td>
                <Button
                  id={"idLigneR_" + index}
                  onClick={(ev) => {
                    deleteLigne(index);
                  }}
                  variant="danger"
                  size="sm"
                  className="text-danger btn-link delete"
                >
                  <i className="fa fa-trash" id={"idLigneR_" + index} />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    );
  };

  const handleDeleteUnknownProducts = async () => {
    try {
      setProduitExistDeleted([...produitExist]);
      const updatedEntitiesReste = entitiesReste.filter(entity =>
        !produitExist.some(product => product.produitfour === entity.produitfour));

      const updatedEntities = entities.filter(entity =>
        !produitExist.some(product => product.produitfour === entity.produitfour)
      );
      setEntitiesReste(updatedEntitiesReste);
      setEntities(updatedEntities);
      setProduitExist([])
      console.log("Unknown products deleted and saved to DB");
    } catch (error) {
      console.log("Error saving unknown products:", error);
    }
  };




  const calculateTotalSum = (entities) => {
    const sum = entities.reduce((acc, curr) => {
      return acc + parseFloat(curr.total || 0); // add total to accumulator, default to 0 if total is undefined
    }, 0); // initial accumulator value is 0

    setTotal(sum);
  };
  const verifToken = useCallback(async () => {
    try {
      dispatch(verification()).then(e => {
        if (e.payload === false) {
          localStorage.clear();
          window.location.replace("/login");
        }
      })
    } catch (error) {
      localStorage.clear();
      window.location.replace("/login");
    }

  }, [dispatch]);
  useEffect(() => {
    getNumCmd(idUser)
    verifToken()
    if(obj.user.id_role != 6 )getGrossiste();
    getproduit(remise_industrie2, remise_industrie3);
  }, [ getproduit, numCmd, remise_industrie3, remise_industrie2]);

  return (
    <>
      <Container fluid className="responsive-BL table-dynamique grossiste-class">
        {alert}

        {txtAlert !== "" ? <Alert variant="danger">{txtAlert}</Alert> : ""}
        <ToastContainer />

        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-outline mr-1 float-left"
              type="button"
              variant="info"
              onClick={() => {
                window.history.back();
              }}
            >
              <span className="btn-label">
                <i className="fas fa-list"></i>
              </span>
              {t('list')}
            </Button>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">{t('new_commande')}

                  <a
                    className="btn btn-success mx-1"
                    onClick={(e) => {
                      e.preventDefault();

                      // Define headers
                      const headers = ["Code PCT", "Code Article", "Article", "Colisage", "Quantite"];

                      // Map products to CSV rows
                      const rows = optionProduit.map((prod) => [
                        prod.code,
                        prod.code_article,
                        prod.label,
                        prod.cartonnage,
                        "" // empty Quantite
                      ]);

                      // Combine into a CSV string
                      const csvContent =
                        [headers, ...rows].map((e) => e.join(";")).join("\n");

                      // Create blob and trigger download
                      const csvContentWithBOM = '\uFEFF' + csvContent; // ✅ ajoute le BOM UTF-8
                      const blob = new Blob([csvContentWithBOM], { type: "text/csv;charset=utf-8;" });

                      const url = URL.createObjectURL(blob);

                      const link = document.createElement("a");
                      link.href = url;
                      link.setAttribute("download", "templateBC.csv");
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    }}
                  >
                    Télécharger template
                  </a>


                </Card.Title>
              </Card.Header>
              <Card.Body>
                <div className="text-center">
                  <Form.Group >
                    <Form.Control
                      type="file"
                      className="custom-file-input"
                      id="inputGroupFile01"
                      aria-describedby="inputGroupFileAddon01"
                      accept=".xlsx, .xls, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/csv"
                      onChange={(e) => {
                        fileHandler(
                          e,
                          grosSelected,
                          testAffiche
                        );
                      }}
                    ></Form.Control>
                  </Form.Group>


                  <br />
                  <Button
                    className="btn-wd btn-outline mr-1 float-right extraction"
                    id="blExt"
                    type="button"
                    variant="info"
                    onClick={(v) => {
                      showTable(uploadFile, entities);
                    }}
                  >
                    <span className="btn-label">
                      <i className="fas fa-cogs"></i>
                    </span>
                    {t("extraction")}
                  </Button>
                </div>
                <br clear="all"></br>
                <hr></hr>


                <Row className="hidden" id="table-BL">


                  {produitExist.length > 0 ?
                    <> <Col md="12">
                      <button className="btn btn-danger ml-1" onClick={handleDeleteUnknownProducts}>Supprimer les Produits Inconnus</button>
                    </Col>
                      <Col md="12">
                        <table className="table tableinconnue">
                          <thead style={{ backgroundColor: produitExist.length > 0 ? 'red' : 'transparent', color: "#fff" }}>
                            <tr>
                              <th style={{ backgroundColor: produitExist.length > 0 ? 'red' : 'transparent', color: "#fff" }}>ID</th>
                              <th style={{ backgroundColor: produitExist.length > 0 ? 'red' : 'transparent', color: "#fff" }}>Code</th>
                              <th style={{ backgroundColor: produitExist.length > 0 ? 'red' : 'transparent', color: "#fff" }}>Designation</th>
                            </tr>
                          </thead>
                          <tbody>
                            {produitExist.map((item, index) => (
                              <tr key={index}>
                                <td>{item.index}</td>
                                <td>{item.code}</td>
                                <td>{item.designation}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </Col>

                    </>
                    : null}


                  <br clear="all"></br>
                  <hr></hr>
                  <br clear="all"></br>

                  <Col md="12">
                    <div>
                      <ReactTable
                        data={entitiesEntete}
                        columns={[
                          obj.user.id_role != 6 && {
                            Header: "Grossiste",
                            accessor: "grossiste",
                            width: 200,
                            Cell: ({ cell }) => (
                              <Select
                                className="react-select"
                                name="Grossiste"
                                placeholder="Grossiste"
                                value={fourSelected}
                                onChange={(v) => {
                                  console.log("👉 Test L : nouveau grossiste sélectionné", v); // 🔥 test log

                                  setFourSelected(v);
                                  var prev = [...entitiesEntete];
                                  prev[0].Grossiste = v.label;
                                  prev[0].id_grossiste = v.value;
                                  prev[0].remise_industrie3 = v.remise_industrie3;
                                  prev[0].remise_industrie2 = v.remise_industrie2;

                                  setRemise_industrie2(v.remise_industrie2);
                                  setRemise_industrie3(v.remise_industrie3);

                                  // 🔥 test recalcul remise
                                  const updatedEntities = entities.map(e => {
                                    let remiseDecimal = 0;
                                    let remise = 0
                                    remiseDecimal = client === "/medis" ? v.remise_industrie2 : v.remise_industrie3;
                                    remise = client === "/medis" ? v.remise_industrie2 : v.remise_industrie3;
                                    if (remiseDecimal > 1) remiseDecimal = remiseDecimal / 100;




                                    return {
                                      ...e,
                                      Remise: remise,
                                      total: e.quantite
                                        ? (e.prix * e.quantite * (1 - remiseDecimal)).toFixed(3)
                                        : 0
                                    };
                                  });
                                  calculateTotalSum(updatedEntities)
                                  setTable(updatedEntities, 1);
                                  setEntitiesEntete(prev);
                                }}

                                options={optionFour}
                                menuPortalTarget={document.body}
                                styles={{
                                  menuPortal: base => ({ ...base, zIndex: 9999 }),
                                }}
                              />
                            ),
                          },
                          {
                            Header: "Numero",
                            accessor: "Numero",
                            Cell: ({ cell }) => (
                              <Form.Group>
                                <Form.Control
                                  defaultValue={cell.row.values.Numero}
                                  placeholder="Numero"
                                  type="text"
                                  readOnly
                                ></Form.Control>
                              </Form.Group>
                            ),
                          },
                          {
                            Header: "Date",
                            accessor: "Date",
                            Cell: ({ cell }) => (
                              <Form.Group>
                                <Form.Control
                                  defaultValue={cell.row.values.Date}
                                  placeholder="Date"
                                  type="date"
                                  readOnly
                                ></Form.Control>
                              </Form.Group>
                            ),
                          }
                        ].filter(Boolean)}
                        className="-striped -highlight primary-pagination"
                      />
                    </div>
                  </Col>
                  <hr></hr>

                  <Col md="12">
                    <hr></hr>
                    <h4 className="float-left"><strong>{t('montant_total')}: {new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(total)} HT TND</strong></h4>
                    <Row className="float-right" style={{ width: "50%", margin: "30px 0 15px" }}>
                      <Col md="12">
                        <Row>
                          <Col md="6">
                            <Form.Group>
                              <Form.Check>
                                <Form.Check.Label>
                                  <Form.Check.Input
                                    type="checkbox"
                                    checked={resteZero == 1 ? true : false}
                                    onChange={(v) => {
                                      if (v.target.checked) {
                                        setResteZero(1);
                                        getProduitReste(entities, 1)
                                      }
                                      else setResteZero(0)
                                    }}
                                  ></Form.Check.Input>
                                  <span className="form-check-sign"></span>
                                  <label>{t('produit_en_vrac')}</label>
                                </Form.Check.Label>
                              </Form.Check>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <br clear="all"></br>
                    <hr></hr>

                    <ListTable entities={resteZero == 0 ? entities : entitiesReste} list={entities} produitSelect={produitSelect} resteZero={resteZero} />
                    <div className="text-center">
                      <img
                        id="loaderTable"
                        src={require("../../assets/img/loader.gif")}
                        alt="loader"
                      />
                    </div>
                    <br></br>
                    <hr></hr>
                    {!isDisabled && resteZero == 0 ?
                      <Button
                        className="btn-wd btn-outline mr-1 float-left"
                        type="button"
                        variant="info"
                        nom="redac"
                        onClick={(ev) => AjoutLigne()}
                      >
                        {t("add_product")}
                      </Button> : null}
                  </Col>


                  {!isDisabled ?
                    <Col md="12">
                      <Button
                        id="saveBL"
                        className="btn-wd btn-outline mr-1 float-right"
                        type="button"
                        variant="info"
                        onClick={() =>
                          saveTable(
                            entities,
                            entitiesEntete,
                            uploadFile,
                            grosSelected,
                            total, produitExistDeleted
                          )
                        }
                      >
                        <span className="btn-label">
                          <i className="fas fa-check"></i>
                        </span>
                        {t("save_draft")}
                      </Button>

                    </Col> : null}

                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}
export default AddCommandeExcel;
